export default "__VITE_ASSET__By9Vz6Oh__"